// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".submit-button.disabled[data-v-2ffbb5fa]{opacity:0.6}\n", ""]);
// Exports
module.exports = exports;
